var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer footer-black footer-white"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('nav',{staticClass:"footer-nav"}),_c('div',{staticClass:"credits ml-auto"},[_c('div',{staticClass:"copyright"},[_vm._v(" Coded with "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Mario Lauterbach ")])])])])])
}]

export { render, staticRenderFns }